// Revoking in the same tick as the click can cancel the download in some browsers.
const REVOKE_AFTER_MS = 1000;

export function saveFile(file: Blob, filename: string): void {
  const address = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = address;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(address), REVOKE_AFTER_MS);
}
